var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticker-wrapper"},[_c('img',{attrs:{"src":_vm.getSticker,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }